import { render, staticRenderFns } from "./SuccessToast.vue?vue&type=template&id=52289c80&"
import script from "./SuccessToast.vue?vue&type=script&lang=js&"
export * from "./SuccessToast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports